import { Component, inject } from "@angular/core";
import { CardModalService } from "@app/shared/card-modal/card-modal.service";
import { TranslateModule } from "@ngx-translate/core";
import { JumpstartComponentsModule } from "@wk/components-v3-angular17";

@Component({
    selector: "wk-south-panel-t1",
    imports: [TranslateModule, JumpstartComponentsModule],
    templateUrl: "./t1-south-panel.component.html",
    styleUrl: "./t1-south-panel.component.scss",
    host: { class: "wk-cm__south-panel__t1" },
})
export class T1SouthPanelComponent {
    public readonly cardModalService = inject(CardModalService);

    onReturnStatusCheckboxChange(event: Event) {
        const inputElement = event.target as HTMLInputElement;
        this.cardModalService.returnStatusDefaultValue.set(inputElement.checked);
    }

    onAssignedStatusCheckboxChange(event: Event) {
        const inputElement = event.target as HTMLInputElement;
        this.cardModalService.assignedStatusDefaultValue.set(inputElement.checked);
    }
}
